import {HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {MonoTypeOperatorFunction, Observable, of, throwError} from 'rxjs';
import {catchError, switchMap} from 'rxjs/operators';
import {HTTP_STATUS} from '../../common/api-helpers';
import {UserRole} from '../../enums/user-role';
import {AuthService} from './auth.service';

@Injectable()
export class AuthClientService extends AuthService {

    public override authorizeWithCredentials(username: string, password: string, twoFACode?: string): Observable<any> {
        return this.authorizeWithCredentialsForRole(UserRole.TRADER, username, password, twoFACode);
    }

    public override authorizeByToken(token: string): Observable<any> {
        const prevLogout$ = this.getToken()
            ? this.sendLogoutRequest().pipe(
                this.bypassAuthErrorResponse()
            )
            : of(null);

        return prevLogout$.pipe(
            switchMap(() => this.authorizeByTokenForRole(UserRole.TRADER, token))
        );
    }

    /**
     * Replaces 401/403 response with of(null).
     * It works only if {@link AuthInterceptor} has not handled it first.
     */
    private bypassAuthErrorResponse<T>(): MonoTypeOperatorFunction<T> {
        return catchError((error: HttpErrorResponse | any) =>
            error instanceof HttpErrorResponse
            && error.status === HTTP_STATUS.UNAUTHORIZED || error.status === HTTP_STATUS.FORBIDDEN
                ? of(null)
                : throwError(error)
        );
    }

}
